// src/pages/Home/components/ComoFuncionaSection.js
//
// Bloco de confianca da home.
//
// Um marketplace novo tem um problema honesto: nao tem prova social ainda.
// A saida comum e forjar - depoimento inventado, "+5.000 clientes", selo de
// nada. Isso queima o site no primeiro comprador que confere.
//
// A saida escolhida aqui e outra: em vez de prova social, PROVA VERIFICAVEL.
// Cada uma das quatro afirmacoes abaixo pode ser conferida pelo leitor no
// proprio site, e nenhuma depende de volume de usuarios.
//
// TODO texto daqui tem que bater com public/llms.txt e src/data/faq.js.
// Se o produto mudar, muda nos tres. Contradicao entre eles e o defeito que
// esse projeto ja pagou caro uma vez.
import React from 'react'
import { Box, Grid, Link as MuiLink, Typography } from '@mui/material'
import { Link as RouterLink } from 'react-router-dom'

import Secao from '../../../components/Layout/Secao'

const PONTOS = [
  {
    titulo: 'Publicar é grátis, sem limite',
    texto:
      'Sem período de teste, sem mensalidade e sem limite de quantos imóveis você cadastra. O anúncio fica no ar pelo tempo que você quiser.'
  },
  {
    titulo: 'Nenhuma comissão sobre a venda',
    texto:
      'Se o imóvel for vendido ou alugado, a plataforma não fica com nada. O que for combinado entre as partes é das partes.'
  },
  {
    titulo: 'Contato direto com quem anuncia',
    texto:
      'Você fala com o proprietário, o corretor ou a imobiliária responsável pelo anúncio. Sem intermediário no meio da conversa.'
  },
  {
    titulo: 'A ordem dos resultados está publicada',
    texto:
      'Impulsionar é o único item pago e é opcional. Anúncio impulsionado aparece antes; entre os demais, o mais recente vem primeiro. A regra está escrita.'
  }
]

const ComoFuncionaSection = () => (
  <Secao fundo='branco' ritmo='padrao'>
    <Typography
      component='h2'
      sx={{ fontSize: { xs: '1.35rem', md: '1.6rem' }, fontWeight: 700, mb: 0.5 }}
    >
      Como o UMARKT funciona
    </Typography>
    <Typography sx={{ color: 'text.secondary', mb: { xs: 3, md: 4 } }}>
      Quatro coisas que você pode conferir agora, sem cadastro.
    </Typography>

    <Grid container spacing={{ xs: 2.5, md: 4 }}>
      {PONTOS.map((p, i) => (
        <Grid size={{ xs: 12, sm: 6, md: 3 }} key={p.titulo}>
          <Box
            sx={{
              height: '100%',
              pt: 2,
              borderTop: '3px solid',
              borderColor: i === 3 ? 'primary.main' : 'divider'
            }}
          >
            <Typography
              component='h3'
              sx={{ fontWeight: 700, fontSize: '1rem', mb: 1, lineHeight: 1.35 }}
            >
              {p.titulo}
            </Typography>
            <Typography sx={{ color: 'text.secondary', fontSize: '.94rem', lineHeight: 1.65 }}>
              {p.texto}
            </Typography>
          </Box>
        </Grid>
      ))}
    </Grid>

    <Typography sx={{ mt: { xs: 3, md: 4 }, fontSize: '.92rem', color: 'text.secondary' }}>
      Os valores do impulsionamento e a regra completa de ordenação estão em{' '}
      <MuiLink component={RouterLink} to='/como-funciona' underline='hover'>
        como funciona
      </MuiLink>{' '}
      e na{' '}
      {/* href normal: /faq.html e arquivo estatico servido pelo nginx, e a
          versao que as IAs leem sem executar JavaScript */}
      <MuiLink href='/faq.html' underline='hover'>
        página de perguntas frequentes
      </MuiLink>
      .
    </Typography>
  </Secao>
)

export default ComoFuncionaSection
